/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pitch_Rules_BodyInputs */



/**
* | output |
* | --- |
* | "Spelling, consistency and inflection are checked against Norsk ordbank, the word bank behind Bokmålsordboka, and follow the Language Council of Norway's spel..." |
*
* @param {Pitch_Rules_BodyInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const pitch_rules_body = /** @type {((inputs?: Pitch_Rules_BodyInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pitch_Rules_BodyInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Spelling, consistency and inflection are checked against Norsk ordbank, the word bank behind Bokmålsordboka, and follow the Language Council of Norway's spelling rules. Much like the spell checker in Word, only far more thorough.")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Stavning, konsekvens och böjning kontrolleras mot Norsk ordbank, som även ligger till grund för Bokmålsordboka, och enligt norska Språkrådets stavningsregler. Ungefär som stavningskontrollen i Word, men betydligt grundligare.")
	return /** @type {LocalizedString} */ ("Rettskriving, konsistens og bøyning kontrolleres mot Norsk ordbank, som også ligger til grunn for Bokmålsordboka, og etter Språkrådets rettskrivingsregler. Omtrent som stavekontrollen i Word, men langt grundigere.")
});